var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardDescription, CardHeader, CardPoints, CardTitle } from './subcomponents';
var PropositionsCard = function (_a) {
    var heading = _a.heading, points = _a.points, description = _a.description, dataCy = _a.dataCy;
    return (_jsxs(Card, __assign({ "data-cy": dataCy }, { children: [_jsxs(CardHeader, __assign({ "data-cy": "val-prop-card-header" }, { children: [_jsx(CardTitle, { children: heading }), _jsx(CardPoints, { children: points })] })), _jsx(CardDescription, __assign({ "data-cy": "val-prop-card-description" }, { children: description }))] })));
};
export default PropositionsCard;
